import { AccountSampleResponse } from "src/models/account";
import { API_ROUTES } from "../data/routes";
import { HttpClient } from "./config";

export const getUserBalance = async (params?: any): Promise<any> => {
    return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_USER_BALANCE}`, {params});
}

export const getAssetEvolution = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_ASSET_EVOLUTION}`, {params});
}

export const getProductLists = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_PRODUCT_LIST}/`, {params});
}

export const getProductAllocation = async (id?: string, params?:any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_PRODUCT}/${id}`, {params});
}

export const getAssetPerformanceEvolution = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_ASSET_PERFORMANCE_EVOLUTION}`, {params});
}

export const getSchemeCapital = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_SCHEME_CAPITAL}`, {params});
}

export const getPendingTransactions = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_PENDING_TRANSACTIONS}`, {params});
}

export const getTransactionsHitory = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_TRANSACTIONS_HISTORY}`, {params});
}


export const getAssociatedAccount = async (params?: any): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_ASSOCIATED_ACCOUNTS}`, {params});
}

export const getCustomerDetails = async (id?: string): Promise<any> => {
  return await HttpClient.get<AccountSampleResponse>(`${API_ROUTES.GET_CUSTOMER}/${id}`);
}

